<script lang="ts" setup>
import { TaskModel } from "@/components/tasks-kanban/models";
import { ListItemModel } from "../../../models";
import { computed, PropType } from "vue";
import { TaskCardItemWrapper } from "./";

/**Параметры */
const props = defineProps({
  /**Задача */
  task: { type: Object as PropType<TaskModel> },
  /**Данные об элемнте */
  element: { type: Object as PropType<ListItemModel> },
});

/**Первый файл */
const firstFile = computed(() => props.task.AttachedFiles?.[0]);
/**Скрытые файлы */
const hiddenFiles = computed(() => Math.max(props.task.AttachedFiles.length - 1, 0));
</script>
<template>
  <TaskCardItemWrapper :element="element">
    <div v-if="firstFile" class="task-card-attached-files">
      <div class="task-card-attached-files_file">
        <div v-text="firstFile.FileName" />
        <div class="ext" v-text="firstFile.FileExtension" />
      </div>
      <div v-if="hiddenFiles" v-text="`+${hiddenFiles}`" class="task-card_circle" />
    </div>
  </TaskCardItemWrapper>
</template>
<style lang="scss" scoped>
.task-card-attached-files {
  display: flex;
  align-items: center;
  gap: 0.125rem;
  &_file {
    display: flex;
    align-items: center;
    gap: 0.25rem;
    padding: 0 0.5rem;
    color: #9d12de;
    background-color: #9d12de1a;
    border-radius: 0.25rem;
    overflow: hidden;
    & > div {
      max-width: 7.125rem;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      &.ext {
        max-width: 2.5rem;
      }
    }
  }
}
</style>
